import {
  resolveAgentLabel,
  resolvePersonaLabel,
} from '@/components/AiAskBar/askBarSelectionDefaults'
import { buildSelectionSwitchBlock } from './demoSelectionSwitch.part01.js'

export function applyDemoSelectionSwitch(state, patch, options) {
  const {
    agentId,
    personaId,
    previousAgentId,
    previousPersonaId,
  } = options

  const patchFields = { blocks: [...state.blocks] }

  if (agentId != null && agentId !== previousAgentId) {
    state.blocks.push(
      buildSelectionSwitchBlock(
        'agent',
        resolveAgentLabel(previousAgentId),
        resolveAgentLabel(agentId),
      ),
    )
    patchFields.askBarAgentId = agentId
    patchFields.blocks = [...state.blocks]
  }

  if (personaId != null && personaId !== previousPersonaId) {
    state.blocks.push(
      buildSelectionSwitchBlock(
        'persona',
        resolvePersonaLabel(previousPersonaId),
        resolvePersonaLabel(personaId),
      ),
    )
    patchFields.askBarPersonaId = personaId
    patchFields.blocks = [...state.blocks]
  }

  if (patchFields.askBarAgentId != null || patchFields.askBarPersonaId != null) {
    patch(patchFields)
  }
}

/**
 * @param {{ blocks: object[] }} state
 * @param {(patch: Record<string, unknown>) => void} patch
 */
